import { apiService } from '../../shared/services/apiService';
import {
  ScanIqCustomerPersonalData,
  ScanIqCustomerProfileInfo,
} from '../interfaces/ScanIqCustomerProfileInfo';

export const scanIqCustomerProfileService = {
  async getCustomerProfileInfo(
    entityId: number,
    customerId: number,
  ): Promise<ScanIqCustomerProfileInfo> {
    const response = await apiService.get(
      `/api/entity/${entityId}/scan-iq/customer/${customerId}/personal-data`,
    );
    return response.data;
  },

  async updateCustomerPersonalData(
    customerId: number,
    personalData: ScanIqCustomerPersonalData,
  ): Promise<ScanIqCustomerPersonalData> {
    const response = await apiService.put(
      `/api/scan-iq/customer/${customerId}/personal-data`,
      personalData,
    );
    return response.data;
  },
};
